import React from 'react';
import { ASSETS_BASE_URL } from '../../../../../constants/endpoints';

interface ICircleWrapperProps {
  children: React.ReactNode;
  className?: string;
  isButton?: boolean;
}

const lightBlueButtonStyles = 'hover:bg-[#EAF3FF] hover:drop-shadow-none hover:border-[0px] active:border-action03 active:border-[1px]';
export const CircleWrapper = ({ children, className = '', isButton }: ICircleWrapperProps) => (
  <div className={`${className || 'h-[56px] w-[56px]'} border-[1px] border-bw03 rounded-full flex items-center justify-center ${isButton ? lightBlueButtonStyles : ''}`}>
    {children}
  </div>
);

interface ICategoryImageProps {
  categoryImageName: string;
  className?: string;
  testId: string;
}
export const CategoryImage = ({ categoryImageName, className, testId }: ICategoryImageProps) => (
  <img data-testid={testId} className={`${className || 'w-[16px] h-[16px]'} object-contain`} alt='Icon' src={`${ASSETS_BASE_URL}/webapp/categories/${categoryImageName}.svg`} />
);
